import { COLORS } from "components/v3/Theme/colors";

export const planCardSx = {
  backgroundColor: COLORS.BACKGROUND_BLUE,
  borderRadius: "12px",
  boxSizing: "border-box",
  maxWidth: "100%",
  minWidth: 0,
  padding: 2.5,
  width: "100%"
} as const;

export const shareModalOptionCardSx = {
  alignItems: "flex-start",
  bgcolor: COLORS.PRIMARY_LIGHTEST,
  border: "2px solid transparent",
  borderRadius: "12px",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: 2,
  justifyContent: "flex-start",
  minWidth: 0,
  padding: "35px 25px",
  textAlign: "left",
  transition: "border-color 0.2s ease",
  width: "100%",
  "& .MuiTypography-root": {
    textAlign: "left",
    width: "100%"
  },
  "&.Mui-focusVisible": {
    borderColor: COLORS.PRIMARY_LIGHTER
  },
  "&:hover": {
    borderColor: COLORS.PRIMARY_LIGHTER
  },
  "& img": {
    mb: "25px"
  }
} as const;
